import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import { type Registry as Services, service } from '@ember/service';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import type { RhsRecord } from 'uplisting-frontend/utils/rhs/types';
import type TranslationsService from 'uplisting-frontend/services/translations';

interface IArgs {
  record: RhsRecord;
  message: ModelRegistry['message'];
  saveReplyRoute: string;
  showTranslation: boolean;
}

interface BookingMessagesMessageInboundSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

export default abstract class UiBookingMessagesMessageBaseComponent extends Component<BookingMessagesMessageInboundSignature> {
  @service intl!: Services['intl'];
  @service translations!: TranslationsService;

  @cached
  get message(): ModelRegistry['message'] {
    return this.args.message;
  }

  @cached
  get record(): RhsRecord {
    return this.args.record;
  }

  @cached
  get displayChannel(): string {
    return this.translations.getChannelNameFor(this.message.type);
  }

  @cached
  get displayContent(): string {
    if (
      this.args.showTranslation &&
      this.message.hasTranslation &&
      this.message.translatedContent
    ) {
      return this.message.translatedContent;
    }

    return this.message.content;
  }

  @cached
  get isShowingTranslation(): boolean {
    return (
      this.args.showTranslation &&
      this.message.hasTranslation &&
      !!this.message.translatedContent
    );
  }
}
